import React from 'react'
import PropTypes from 'prop-types'
import IconLabel from './IconLabel'
import {CheckSquareFilled} from '@ant-design/icons'

const FloorPlansProduct = ({product}) => {
  if (product.measurement) {
    return (
      <div className="selected-product-options FloorPlansProduct">
        <IconLabel icon={<CheckSquareFilled />} label="Oppmåling" />
      </div>
    )
  }

  return null
}

FloorPlansProduct.propTypes = {
  product: PropTypes.object.isRequired,
}

export default FloorPlansProduct
